import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export type ScrollToTopProps = {
  children: React.ReactNode;
};

/**
 * Scrolls to top of page on route changes.
 * Wrap your app content with this component inside the Router.
 */
export function ScrollToTop({ children }: ScrollToTopProps) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <>{children}</>;
}
